import type { ModalFooterFactory, IProps } from "./modal-footer.types";
import styles from "../modal.module.scss";
import { componentWrapper } from "../../../utilities";
import { Box } from "../../box";
import { ModalFooterActions } from "./modal-footer-actions";

const ModalFooter = componentWrapper<ModalFooterFactory, IProps>("ModalFooter", (props, ref) => {
    return <Box ref={ref} className={styles["footer"]} {...props} />;
});

ModalFooter.Actions = ModalFooterActions;

export { ModalFooter };
